
import {getGlobal, getSnip, setSnip} from 'launchpad';
import React from 'react';
import Fade from 'react-move-stuff';

export function plainText(html){
  return html.replace(/<[^>]+>/g, '')
}

export default class FancySnip extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      mode: 'static',
      value: ''
    }
  }

  pushChange() {
    if(this.div){
      let text = plainText(this.div.innerHTML);
      if(typeof this.props.onChange == 'function'){
        this.props.onChange(text);
      }
      if(text == '') {
        this.div.innerHTML = '';
      }
      setSnip(this.div.innerHTML, this.props.order, this.props.id, this.props.page);
    }
  }

  handleChange(e) {
    // update snips which share page/id
    let siblings = document.querySelectorAll("#"+this.props.id+".group-"+this.props.page);
    for(let x of siblings){
      if(x != this.div){
        x.innerHTML = this.div.innerHTML;
      }
    }

    if(this.debounceTimer){
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {this.pushChange()}, 300);
  }

  select(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({editing: true}, () => setTimeout(() => this.div.focus(), 500))
  }

  render() {
    if(this.props.render){
      return this.props.render(this)
    } else {
      let snip = getSnip(this.props.id, this.props.page);
      let content = plainText(snip.content)
      let editable = {};
      if(getGlobal('is_admin') && !this.props.disabled){
        editable = {
          onInput: (e) => this.handleChange(e),
          onClick: (e) => this.select(e),
          onFocus: () => this.setState({editing: true}),
          onBlur: () => this.setState({editing: false})
        }
        if(getGlobal('editImages')){
          editable.contentEditable = true
        }
      } else {
        if(isNaN(content)){
          content = content.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
        }
      }

      const words = content.split(' ');
      const totalWords = words.length;
      let currentWord = 0;
      let delay = (this.props.duration || 1) / totalWords
      let dynamicContent = (
        content ? words.map(word => {
          currentWord++;
          return <Fade inline key={currentWord * 1} delay={currentWord * delay} {...this.props}>{word+' '}</Fade>
        }) : 'Lorem ipsum...'
      )
      if(dynamicContent.forEach){
        let wordList = []
        dynamicContent.forEach(word => {
          wordList.push(word);
          wordList.push(' ');
        })
        dynamicContent = wordList;
      }

      return (
        <div id={this.props.id}
          className={'snip group-'+ this.props.page + (this.props.className || '')}
          ref={div => {this.div = div}}
          {...editable}
        >
          {getGlobal('editImages') ? content.replace('&nbsp;', ' ') : dynamicContent}
        </div>
      );
    }
  }
}
